module.exports = __webpack_public_path__ + "static/img/training11.dc8b8119.jpg";